<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" style="height: 100%;">
    <mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
      <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
        <mat-card-title>
          <div class="w-100 d-flex" style="background: #0f172a;">
            <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">{{ "Liaison Sage : Nouvelle synchronisation" | translate }}</span>
            <button class="m-l-auto" mat-icon-button (click)="closeDialog()">
              <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
            </button>
          </div>
        </mat-card-title>
        <mat-card-subtitle style="background: #dee8ff;color: black;" class="p-t-16 p-b-16">
          <div class="d-flex">
            <div class="d-flex flex">
              <div style="border-right: 2px solid #1855d5; margin-right: 15px;">
                <button mat-icon-button>
                  <i-tabler name="activity" class="icon-24 d-flex" style="color: #1cc8ff; align-items: center;"></i-tabler>
                </button>
              </div>
              <div class="d-grid">
                <span class="f-w-700"> {{ "Nouveau" | translate }} </span>
                <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;"> {{ "Synchroniser données Sage vers CaurisLinkUp" | translate }}</span>
              </div>
            </div>
            <div class="m-l-auto">
            </div>
          </div>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content style="flex: 1;padding: 0;">
        <div class="row" style="padding: 30px;">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100"> 
                    <mat-label>Bases SAGE</mat-label>
                    <mat-select formControlName="ALIAS_IDS" multiple>
                        <ng-container *ngFor="let alias of aliases">
                            <mat-option [value]="alias.ID">{{ alias.NOM_ALIAS }}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="error-container" *ngIf="!!errorText">{{ errorText }}</div>
      </mat-card-content>
      <mat-card-actions class="d-block m-0 p-0" style="background-color: #ffffff; border-top: 3px solid #5d87ff;">
        <div class="d-flex w-100" style="padding-top: 6px;">
          <button type="button" mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;" (click)="closeDialog()">
            {{ "ANNULER" | translate }}
          </button>
          <button mat-flat-button color="ccdark" [disabled]="!formGroup.valid || loading" style="font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;">
            <ng-container *ngIf="loading"><mat-spinner diameter="25"></mat-spinner></ng-container>
            <ng-container *ngIf="!loading">{{ "VALIDER" | translate }} </ng-container>
          </button>
        </div>
      </mat-card-actions>
    </mat-card>
  </form>